// Exports
export default {
	"BackgroundAudioButton": "BackgroundAudioButton_wMR+Z"
};
